import { NEW_ERROR } from '../actions/AddError';
import { ERROR_DISMISSED } from '../actions/DismissError';

const initialState = {
  counter: 0,
  errors: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NEW_ERROR:
      return {
        counter: state.counter + 1,
        errors: state.errors.concat([
          Object.assign({}, action.error, {
            id: state.counter + 1,
          }),
        ]),
      };
    case ERROR_DISMISSED:
      return Object.assign({}, state, {
        errors: state.errors.filter(errors => errors.id !== +action.errorId),
      });
    default:
      return state;
  }
};
